import {CartLineMapper} from "@app/core/cart/infrastructure/mappers/cart-line.mapper";
import {CartPromotion} from "../../domain/dtos/cart-promotion";

export class CartPromotionMapper {
    static deserialize(param: any): CartPromotion {
        return {
            // To make sure that the promotion code is a string we use the toString() method.
            // This is because the id can be a number or a string, depending on the API endpoint.
            code: param.id.toString(),
            totalPrice: param.total_price,
            products: param.products.map(CartLineMapper.deserialize)
        }
    }

    static serialize(param: CartPromotion): any {
        return {
            id: param.code,
            total_price: param.totalPrice,
            products: param.products.map(CartLineMapper.serialize)
        }
    }
}
